import moment from "moment";

export class DiscountsService {
    constructor(axios, apiUrl, store) {
      this.$axios = axios;
      this.apiUrl = apiUrl;
      this.store = store;
    }

    /**
     * Get a discount by id
     * @returns Discount
     */
     async getDiscountsByCompany(sqldbid) {
      return await this.$axios.get(this.apiUrl + `Discounts/SG/Company/${sqldbid}`).then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        return undefined;
      });
    }

    async getDiscountCode(sqldbid, discountCodeId) {
      try {
        const response = await this.$axios.get(`${this.apiUrl}Discounts/RGS/Company/${sqldbid}/DiscountCode/${discountCodeId}`);
        return response.data;
      } catch (ex) {
        console.error(ex);

        return undefined;
      }
    }

    getExistingCustomerPrePayDiscount() {
      const customerStatusCharacter = this.store.state.persistedState?.customer?.statusCharacter;
      if (!["8", "9"].includes(customerStatusCharacter)) {
        return undefined;
      }

      const prePayDiscounts = this.store.state.persistedState?.branchInfo?.UPWebsite?.PrePayDiscount;

      if (!Array.isArray(prePayDiscounts)) {
        return undefined;
      }

      const currentDate = moment();

      return prePayDiscounts?.find((prePayDiscount) => {
        const startMoment = moment(prePayDiscount?.StartDate);
        const endMoment = moment(prePayDiscount?.EndDate);

        return prePayDiscount?.CustType === "Existing" && currentDate.isBetween(startMoment, endMoment);
      });
    }
}
